/*    
<summary>
  This functional component "ChangePasswordForm" provides form to change the password of the selected user.
  Developer:Aashish Singh, Created Date:29-August-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";
import { Form, Formik, Field } from "formik";
import { FormattedMessage } from "react-intl";
import { Modal, Button } from "react-bootstrap";
import { IUpdateCustomerEmail, IUpdatePassword } from "../../../../models/forms/IChangePassword";
import { formatMessage } from "../../../../translations/format-message";

import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import Label
    from "../../../../shared-components/label/label";
import { ShowHidePasswordButton } from "../../../../shared-components/Grid/custom-grid-formatter";
import LoaderButton from "../../../../shared-components/button/loader-button";
import { CustomerEmailValidation } from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";


interface IProps {
    id: number;
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
    loading: boolean;
    initialValues: IUpdateCustomerEmail;
}

const ChangeCustomerEmailForm = (props: IProps) => {

    return (
        <>
            <Modal
                className="changePasswordModal correction-modal fancy-modal"
                show={true}
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <button
                            title={formatMessage("close")}
                            onClick={props.onModalClosed}
                            disabled={props.loading}
                            className="Crossicons"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="23"
                                fill="currentColor"
                                className="bi bi-x"
                                viewBox="0 0 16 16"
                            >
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </button>
                        <FormattedMessage id="change_email" />
                    </Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={props.initialValues}
                    enableReinitialize
                    validationSchema={CustomerEmailValidation}
                    validateOnBlur={false}
                    onSubmit={async (values) => {
                        props.submitHandler(values);
                    }}
                >
                    <Form>
                        <Modal.Body>
                            <div className="form-group">
                                <Label
                                    className="label-style"
                                    required={true}
                                    label="email"
                                />
                                <Field
                                    className="form-control"
                                    name="Email"
                                    type="email"
                                    autoComplete="new-email"
                                    placeholder="enter_email"
                                    validcharacter={["@", "#", "$", "-", "_", "."]}
                                    as={FormikFormInput}
                                />
                            </div>


                        </Modal.Body>
                        <div className="modal-footer border-0">
                            <Button
                                variant="outline-danger me-2"
                                disabled={props.loading}
                                onClick={props.onModalClosed}
                            >
                                <i className="bi bi-x-lg me-1"></i><FormattedMessage id="close" />
                            </Button>
                            <LoaderButton
                                type="submit"
                                iconName="bi-check-lg"
                                isLoading={props.loading}
                                text="button_save"
                            />
                        </div>
                    </Form>
                </Formik>
            </Modal>
        </>
    );
};

export default ChangeCustomerEmailForm;
